import styled from 'styled-components';

export const ContainerRadioButton = styled.div`
  margin: 0px 3px;
`;
